// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".mp-filter-menu .mp-filter-menu-header{border-bottom:1px solid var(--component-outline-color);display:flex;margin-top:-12px}.mp-filter-menu .mp-filter-menu-header .mp-filter-menu-cohort-options{flex:1;margin:8px}", ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
